import useRepo from '@/nebula/repo';
import { appIntegration as appIntegrationConfig } from 'shared/api/query/configs.json';

export default function useAppIntegration() {
  const repo = useRepo(appIntegrationConfig.model);

  return { ...repo };
}
